module.exports = __webpack_public_path__ + "img/12.9cf871c5.webp";